module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAJ1BMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8edxOHz+Pv////a6fSPHyASAAAACHRSTlMAYL//ACDP71kzCuAAAACeSURBVHgB7ZbBDcFhDEc7AxOICXgH/4NjmUBMwAS2YQIxAT1aTJxommgdOPXdXvKOX/r9RGTERyaqolsS9iqrAwmLjaxJ2cmYlJlMSZkLBV5RR8PRzkBQFy3N7A5BXXQysysEddHFzG4Q9S0a7AlE/TbCR3T0hyjS0a+ifnQd1Q9reqLrxx7/bTgVCnREbdCUplFpZJXmWmn4qeYT8gFmWx1wb/cQcQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f1ed.png
// module id = 598
// module chunks = 0